//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'
import HolyWoodBanner from '../../components/Banners/DentBanners/HolyWoodBanner.vue';
import GeneralBanner from '../../components/Banners/GeneralBanners/GeneralBanner.vue';
import WeightLossSurgeryBanner from '../../components/Banners/ObesityBanners/WeightLossSurgeryBanner.vue';
import GeneralDentBanner from '../../components/Banners/DentBanners/GeneralDentBanner.vue';
import AlignedSmileBanner from '../../components/Banners/DentBanners/AlignedSmileBanner.vue';
import HairRegainBanner from '../../components/Banners/HairBanners/HairRegainBanner.vue';
import MissingTeethBanner from '../../components/Banners/DentBanners/MissingTeethBanner.vue';
import DietTreatmentBanner from '../../components/Banners/ObesityBanners/DietTreatmentBanner.vue';
import HairTransplantBanner from '../../components/Banners/HairBanners/HairTransplantBanner.vue';


export default {
  layout: 'blog',
  name: 'index',
  mixins: [SEO, JSONSCHEMA],
  data() {
    return {
      shareOpen: false,
      page: [],
      nodesLength: 0,
      nodeSplitter: 0
    }
  },

  components: {
    HolyWoodBanner,
    GeneralBanner,
    AlignedSmileBanner,
    HairRegainBanner,
    MissingTeethBanner,
    DietTreatmentBanner,
    HairTransplantBanner,
    GeneralDentBanner,
    WeightLossSurgeryBanner,

  },

  methods: {
    copyLinksTemplate() {
      const copyText = `${this.$i18n.t('copy')}`;
      const headers = document.querySelectorAll('.inner-content h1,.inner-content h2, .inner-content h3, .inner-content h4, .inner-content h5,.inner-content h6')
      headers.forEach(item => {
        if (item.textContent.length <= 0 || item.id === '') {
          return
        }
        const parentEl = document.createElement('div')
        parentEl.id = 'parent' + item.id
        item.classList.add("d-inline")
        item.parentNode.insertBefore(parentEl, item)
        parentEl.append(item)
        document.querySelector(`#parent${item.id}`).innerHTML += `<button  class="copyToClipboard mx-2 text-dark bg-transparent border-0"
        id="${item.id}" title="${copyText}" data-target="${item.id}" ><i class="fas fa-regular fa-link"></i></button>`
      })
      const copyToClipboard = document.querySelectorAll('.copyToClipboard')
      copyToClipboard.forEach(item => {
        item.addEventListener('click', () => {
          let $temp = document.createElement("input");
          const value = item.getAttribute('data-target');
          const body = document.querySelector('body')
          body.append($temp);
          let loc = window.location.href
          loc = loc.split('#')[0]
          $temp.value = (`${loc}#${value}`)
          navigator.clipboard.writeText($temp.value)
          this.$toast.success(this.$t("copied"), {
            duration: 1000,
          });

          $temp.remove();
        })
      })
    }
  },
  async asyncData({ app, params, error }) {
    try {
      const response = await app.$api.fetchSinglePost(params.slug);
      console.log(response.content, 'response content');

      return {
        page: response.content
      };
    } catch (e) {
      error({ statusCode: 404 });
    }
  },

  computed: {
    parsedContent() {
      if (!this.page || !this.page.content) {
        return [];
      }

      try {
        const parser = new DOMParser();
        // Parse the content string into a DOM document
        const doc = parser.parseFromString(this.page.content, 'text/html');
        // Extract all child nodes of the body element
        const nodes = doc.body.childNodes;
        // Convert the NodeList to an array
        const nodesArray = Array.from(nodes);

        // The following lines have issues - nodeSplitter and nodesLength are not defined
        // so I've removed them or you can define them properly in your data() section
        // nodesLength.value = nodesArray.length;
        // nodeSplitter.value = Math.floor(nodesLength.value / 9);
        // console.log(nodeSplitter.value, 'nodeSplitter.value');

        return nodesArray;
      } catch (error) {
        console.error("Error parsing content:", error);
        return [];
      }
    },
    midIndex() {
      return Math.floor(this.parsedContent.length / 2);
    },
    threeQuarterIndex() {
      return Math.floor((this.parsedContent.length * 3) / 4);
    },
    bannerPlacementIndices() {
      const targetIndices = [
        5,
        11,
        this.midIndex,
        this.threeQuarterIndex
      ];
      const placementIndices = {};
      targetIndices.forEach(targetIndex => {
        // Ensure the targetIndex is within bounds
        if (targetIndex >= 0 && targetIndex < this.parsedContent.length) {
          const node = this.parsedContent[targetIndex];
          // Check if the node at the target index is a DIV or H2

          if (node && node.tagName != 'P') {
            // If it is, place the banner after the next node
            placementIndices[targetIndex] = targetIndex + 3;
            console.log(placementIndices[targetIndex], 'placementIndices[targetIndex]');
          } else {
            // Otherwise, place the banner after the current node (at the target index)
            placementIndices[targetIndex] = targetIndex;
          }
        }
        // If targetIndex is out of bounds, it won't be added to placementIndices,
        // effectively skipping banner placement for that target.
      });
      return placementIndices;
    }
  },
  mounted() {
    //  Slider starts
    this.copyLinksTemplate()
    const previous = document.querySelector(".prev");
    if (previous) {
      const next = document.querySelector(".next");
      const navigations = document.querySelector(".navigations")
      const slides = document.getElementsByClassName("slide");
      let current = 0;
      if (slides.length === 1) {
        navigations.classList.add("hide")
      }
      if (this.$i18n.locale !== 'ar') {
        next.classList.add("rotate")
        previous.classList.add("rotate")
      }
      //  move to the next slide
      next.addEventListener("click", function () {
        slides[current].classList.remove("active");
        current++;
        if (current === slides.length)
          current = 0;
        slides[current].classList.add("active");
      });

      //  move to the previous slide
      previous.addEventListener("click", function () {
        slides[current].classList.remove("active");
        current--;
        if (current < 0)
          current = (slides.length - 1);
        slides[current].classList.add("active");
      });
      //  Slider ends
    }


    var mceToc = document.getElementsByClassName('mce-toc')[0]
    if (mceToc) {
      mceToc.classList.remove('card')
      mceToc.contentEditable = 'false'
    }

    const button = document.querySelectorAll('.inner-content .faq-list .card button');
    const collapse = document.querySelectorAll('.inner-content .faq-list .card .collapse');
    //collapse all FAQ first
    collapse.forEach(faq => {
      faq.classList.remove('show')
    })
    button.forEach(btn => {
      btn.setAttribute("aria-expanded", "false");
      //if there is an open question close it on click
      btn.addEventListener('click', (element) => {
        if (btn.getAttribute("aria-expanded") === 'true') {
          element.target.parentElement.parentElement.nextElementSibling.classList.remove("show")
          btn.setAttribute("aria-expanded", "");
          // console.log("aria-expanded should be false and show class should be removed and hide class should be added")
        }
        //else it's close, so open it on click.
        else {
          btn.setAttribute("aria-expanded", "true");
          element.target.parentElement.parentElement.nextElementSibling.classList.add("show")
        }
      })
    })
  },
}
